import { useCurrentWorkspaceFeatures } from "@dashboard/workspaces/api/helpers";

/**
 * Whether the current workspace has at least one enrolled device, read from the licenses it has used up.
 * `undefined` while the workspace features are still loading, cannot be loaded or carry no license usage, so a
 * caller never mistakes missing data for an empty workspace.
 */
export function useHasEnrolledDevice(): boolean | undefined {
    const { data: features } = useCurrentWorkspaceFeatures();
    const licensesUsed = features?.find((feature) => feature.feature === "LicenseLimit")?.used;
    return licensesUsed === undefined ? undefined : licensesUsed > 0;
}
